import * as React from "react";
const SvgDownTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 18L20 23L25 18H15Z", fill: "#0B4566" }));
export default SvgDownTriangle;
